export const HomeSvg = (color?: string) => (
	<svg width="31" height="30" viewBox="0 0 31 30" fill={'none'} xmlns="http://www.w3.org/2000/svg">
		<path
			d="M11.4961 3.55008L4.75863 8.80008C3.63363 9.67508 2.72113 11.5376 2.72113 12.9501V22.2126C2.72113 25.1126 5.08363 27.4876 7.98363 27.4876H22.4586C25.3586 27.4876 27.7211 25.1126 27.7211 22.2251V13.1251C27.7211 11.6126 26.7086 9.67508 25.4711 8.81258L17.7461 3.40008C15.9961 2.17508 13.1836 2.23758 11.4961 3.55008Z"
			stroke={color || '#4A919E'}
			strokeWidth="1.875"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			opacity="0.34"
			d="M15.2211 22.4875V18.7375"
			stroke={color || '#4A919E'}
			strokeWidth="1.875"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
